import { ImageSizeDefinition } from './types';

export const IMAGE_PROVIDER_PIM_BASE_URL = 'https://igp-pim.imgix.net/';

export enum ImageType {
  aspectRatio = 'aspectRatio',
  fillContainer = 'fillContainer',
}

export enum ImageFitType {
  crop = 'crop',
  fill = 'fill',
}

export enum ImageObjectFitType {
  contain = 'contain',
  cover = 'cover',
}

export enum ImageFillColor {
  transparent = 'transparent',
  white = 'white',
}

export enum ImageTransformType {
  pageHeader = 'pageHeader',
  teaserCardImg = 'teaserCardImg',
  picto = 'picto',
  safetyLabel = 'safetyLabel',
}

export const IMAGE_TRANSFORMER_MAP: Record<ImageTransformType, ImageSizeDefinition> = {
  pageHeader: {
    aspectRatio: '75:46',
    min1746: 1800,
    max1745: 1800,
    max1440: 1500,
    max1200: 1200,
    max960: 1000,
    max640: 700,
  },
  teaserCardImg: {
    aspectRatio: '1:1',
    min1746: 800,
    max1745: 800,
    max1440: 800,
    max1200: 300,
    max960: 300,
    max640: 500,
  },
  picto: {
    aspectRatio: '1:1',
    width: 64,
  },
  safetyLabel: {
    aspectRatio: '297:210',
    min1746: 906,
    max1745: 896,
    max1440: 800,
    max1200: 650,
    max960: 824,
    max640: 504,
  },
};
